'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const designSystem = require('@zapier/design-system');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const button = "_button_3i2l4_9";
const spinnerWrapper = "_spinner-wrapper_3i2l4_52";
const fadeIn = "_fade-in_3i2l4_1";
const content = "_content_3i2l4_56";
const styles = {
	button: button,
	spinnerWrapper: spinnerWrapper,
	fadeIn: fadeIn,
	content: content
};

const Button = (_a) => {
  var { children, className, iconEnd, iconStart, id, isDisabled = false, isLoading = false, onPress, onPressEnd, onPressStart, size = "medium", style, type = "button", variant = "primary", "aria-label": ariaLabel } = _a, props = tslib_es6.__rest(_a, ["children", "className", "iconEnd", "iconStart", "id", "isDisabled", "isLoading", "onPress", "onPressEnd", "onPressStart", "size", "style", "type", "variant", "aria-label"]);
  return React__default.default.createElement(
    reactAriaComponents.Button,
    Object.assign({}, props, { "aria-busy": isLoading, "aria-label": isLoading ? "pending" : ariaLabel, "aria-live": isLoading ? "polite" : void 0, className: clsx.clsx(className, styles.button), "data-a11y-ignore": variant === "brand" ? "color-contrast" : void 0, "data-has-icon-end": iconEnd ? true : void 0, "data-has-icon-start": iconStart ? true : void 0, "data-loading": isLoading, "data-size": size, "data-variant": variant, "data-zds": true, id, isDisabled: isDisabled || isLoading, onPress, onPressEnd, onPressStart, style, type }),
    isLoading && React__default.default.createElement(
      "div",
      { className: styles.spinnerWrapper },
      React__default.default.createElement(designSystem.Spinner, null)
    ),
    React__default.default.createElement(
      "div",
      { className: styles.content },
      iconStart,
      children,
      iconEnd
    )
  );
};

exports.Button = Button;
//# sourceMappingURL=Button.cjs.js.map
